export default __webpack_public_path__ + "static/media/library.9fc007f7.jpg";